import React, { useEffect, useState } from 'react';
import { Modal, Form, Spin, Input, Select, DatePicker, Button } from 'antd';
import { toast } from 'react-toastify';
import { useGetPaymentMethodsQuery, useGetAllPaymentDataQuery, useGetIncomeNameQuery } from "../slices/getSlice";
import dayjs from 'dayjs';
import {
    useAddPaymentMethodMutation
} from "../slices/apiSlice";
import { MdOutlinePayment } from "react-icons/md";
import { FaHandHoldingDollar, FaRegCalendarCheck } from "react-icons/fa6";
import { useSelector } from "react-redux";
import {
    RiStickyNoteLine,
} from "react-icons/ri";
import { PiHouseLine } from "react-icons/pi";
import { SlCalender } from "react-icons/sl";

const IncomeModel = ({
    isModalOpen,
    closeAndReset,
    linkData,
    form,
    isLoadingForm,
    properties,
    handleFinish
}) => {
    const { data: paymentMethodData, refetch: refetchPaymentMethods } = useGetPaymentMethodsQuery();
    const { data: getCategory, refetch: refetchCategory } = useGetAllPaymentDataQuery('income');
    const { data: incomeNameData, refetch: refetchIncomeName } = useGetIncomeNameQuery();
    const [incomeType, setIncomeType] = useState([]);
    const [tpyeOfIncomeList, setTypeOfIncomeList] = useState([]);
    const [IncomeNameList, setIncomeNameDataList] = useState([]);
    const [formValues, setFormValues] = useState([]);
    const [SelectedTypeOfIncome, setSelectedTypeOfIncome] = useState(null);
    const [selectedIncomeType, setSelectedIncomeType] = useState(null);
    const [inputValue, setInputValue] = useState();
    const [loaderValue, setLoaderValue] = useState(false);
    const [incomeTypeOpen, setIncomeTypeOpen] = useState(false);
    const [addPaymentMethod, { isLoading: paymentTypeLoading }] = useAddPaymentMethodMutation();
    const [isSaving, setIsSaving] = useState(false);
    const [newlyAddedIncomeType, setNewlyAddedIncomeType] = useState(null);
    const [IncomeNameValue, setIncomeNameValue] = useState(null);
    const [incomeDropdownOpen, setIncomeNameDropdown] = useState(false);
    const [loadingIncomeName, setLoadingIncomeName] = useState(false);
    const colors = useSelector((state) => state?.persistedReducer?.colors);

    const disabledDate = (current) => {
        return current && current.year() > dayjs().year();
    };

    useEffect(() => {
        if (paymentMethodData) {
            const transformedOptions = paymentMethodData?.data.map((item) => ({
                label: item.payment_mode,
                value: item.id,
            }));
            setIncomeType(transformedOptions);
        }

    }, [paymentMethodData]);

    const [dropdownOptions, setDropdownOptions] = useState([]);

    useEffect(() => {
        if (incomeNameData?.data !== undefined && typeof incomeNameData.data === "object") {
            const dataArray = Object.values(incomeNameData.data);
            const transformedOptions = dataArray.map((item) => ({
                label: item?.notes,
                value: item?.id,
            }));
            setIncomeNameDataList(transformedOptions);
            setDropdownOptions(transformedOptions);
        }
    }, [incomeNameData]);

    useEffect(() => {
        if (getCategory && getCategory.data) {
            const transformedOptions = getCategory.data.map((item) => ({
                label: item.name,
                value: item.id,
            }));
            setTypeOfIncomeList(transformedOptions);
        }

    }, [getCategory]);

    const renderAmount = () => {
        let amount = 0;
        if (linkData && typeof linkData.amount === 'number') {
            amount = linkData.amount.toFixed(2);
        }
        return amount;
    };

    const handleFormSubmit = (value) => {
        value.amount = linkData.amount.toFixed(2);
        handleFinish(value);
    }

    const FrequencyOptions = [
        { label: "Daily", value: "daily" },
        { label: "Weekly", value: "weekly" },
        { label: "Bi-Weekly", value: "biweekly" },
        { label: "Monthly", value: "monthly" },
        { label: "Yearly", value: "yearly" },
    ];

    const handleFieldChange = (field, value, setFormValues) => {
        const updatedFormValues = {
            ...formValues,
            [field?.name]: value?.format ? value.format("YYYY-MM-DD") : value,
        };

        setFormValues(updatedFormValues);

        if (field?.name === 'notes') {
            form.setFieldsValue({
                notes: value
            })
        }
        if (field?.onChange) {
            field.onChange(value);
        }
    };

    const handlePaymentDropdownChange = (visible) => {
        setIncomeTypeOpen(visible);
    };

    const handleSearch = (value) => {
        if (value !== true && value !== undefined) {
            setInputValue(value);
        }
    }

    const handleTypeOfIncomeChange = (value) => {
        setSelectedTypeOfIncome(value);
        setIncomeTypeOpen(false);
    };

    const handleIncomeTypeChange = (value) => {
        setSelectedIncomeType(value);
    };

    const handleAddTypeofIncome = async (data) => {
        const formData = {
            payment_mode: data,
        }
        try {
            const response = await addPaymentMethod(formData);
            if (response.data) {
                toast.success("Income Type added successfully!");
                let newList = await refetchPaymentMethods();
                const transformedOptions = newList.data.data.map((item) => ({
                    label: item.payment_mode,
                    value: item.id,
                }));
                setIncomeType(transformedOptions);
                let newPayment = transformedOptions?.find((item) => item?.label === data);
                setNewlyAddedIncomeType(newPayment?.value);
                form.setFieldsValue({
                    payment_mode_id: newPayment?.value
                })
                setIncomeTypeOpen(false);
            } else {
                toast.error(`${response?.error?.data?.message}`);
            }
        } catch (error) {

        } finally {
            setIsSaving(false)
        }
    };

    const handleAddIncomeType = () => {
        handleAddTypeofIncome(inputValue);
        setLoaderValue(true);
        showLoader();
    };

    const showLoader = () => {
        setTimeout(() => {
            setLoaderValue(false);
        }, 2000);
    };

    const addNewOption = (field, value) => {
        if (!value) return;

        const matchedOption = IncomeNameList.find(
            (opt) => opt.label.toLowerCase() === value.toLowerCase()
        );

        if (!matchedOption) {
            const newOption = { value, label: value };
            setDropdownOptions([...IncomeNameList, newOption]);
            toast.success("New Income name added!");
            form.setFieldsValue({
                notes: value
            });
        }

        handleFieldChange(field, value, setFormValues);
        setIncomeNameDropdown(false);
    };

    return (
        <Modal
            className="deleteModal addTransCustomModal customIncomeModal"
            open={isModalOpen}
            onCancel={closeAndReset}
            footer={false}
            title={
                <>
                    Add your Income
                    <div style={{ marginTop: '8px', fontWeight: 700, width: 'fit-content', fontSize: '1rem' }}>
                        ${renderAmount()}
                    </div>
                </>
            }
        >
            <p className="transaction-name">Transaction Name - {linkData?.name}</p>
            <div className="modal-body">
                {isLoadingForm ? (
                    <Spin style={{ display: "flex", justifyContent: "center", margin: "20px 0" }} />
                ) : (
                    <>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={(values) => handleFormSubmit(values)}
                            initialValues={{
                                properties: [],
                                utilityCategory: [],
                                splitPayment: false,
                                future_add: true,
                            }}
                            className="transactionForm"
                        >
                            <div className="accountNumberWrapper">
                                <Form.Item
                                    label="Card / Account No."
                                    name="mask"
                                >
                                    <Input disabled className="form-control" />
                                </Form.Item>
                            </div>
                            <div className="accountNumberWrapper">
                                <Form.Item
                                    label="Billing Descriptor"
                                    name="billing_descriptor"
                                >
                                    <Input disabled className="form-control" />
                                </Form.Item>
                            </div>

                            <div className="textRow me-2">
                                <Form.Item
                                    label="Property Name"
                                    className="firstFormItem"
                                    name="property_id"
                                    rules={[{ required: true, message: "Please select at least one property." }]}
                                >
                                    <Select
                                        className="formControl select-custom"
                                        style={{ width: "100%" }}
                                        placeholder="Select property"
                                        labelInValue
                                        options={properties}
                                        showSearch
                                        suffixIcon={
                                            <PiHouseLine style={{ color: "#F47939", fontSize: "25px" }} />
                                        }
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                    />
                                </Form.Item>
                            </div>

                            <div className="textRow me-2 mt-2">
                                <Form.Item
                                    label="Type of Income"
                                    className="firstFormItem"
                                    name="category_id"
                                    rules={[{ required: true, message: "Please select type of Income." }]}
                                >
                                    <Select
                                        className="formControl select-custom"
                                        style={{ width: "100%" }}
                                        placeholder="Select property"
                                        labelInValue
                                        options={tpyeOfIncomeList}
                                        showSearch
                                        suffixIcon={
                                            <FaHandHoldingDollar style={{ color: "#F47939", fontSize: "25px" }} />
                                        }
                                        onChange={handleTypeOfIncomeChange}
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                    />
                                </Form.Item>
                            </div>

                            <div className="textRow me-2 mt-2">
                                <Form.Item
                                    label="Income Type"
                                    className="firstFormItem"
                                    name="payment_mode_id"
                                    rules={[{ required: true, message: "Please select Income type." }]}
                                >
                                    <Select
                                        className="formControl select-custom"
                                        style={{ width: "100%" }}
                                        placeholder="Select property"
                                        labelInValue
                                        options={incomeType}
                                        showSearch
                                        open={incomeTypeOpen}
                                        onChange={(value) => {
                                            handleIncomeTypeChange(value);
                                            setIncomeTypeOpen(false);
                                        }}
                                        onDropdownVisibleChange={handlePaymentDropdownChange}
                                        optionLabelProp="label"
                                        loading={paymentTypeLoading}
                                        onSearch={handleSearch}
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                        notFoundContent={
                                            paymentTypeLoading ? (
                                                <div style={{ textAlign: "center", padding: "10px" }}>
                                                    <Spin size="small" />
                                                    <div>Loading...</div>
                                                </div>
                                            ) : incomeType?.length === 0 && !inputValue
                                                ? null
                                                : "No matching records found!"
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                let matchedOption;
                                                if (inputValue) {
                                                    matchedOption = incomeType?.find(
                                                        (opt) => opt.label.toLowerCase() === inputValue.toLowerCase()
                                                    );
                                                    if (!matchedOption) {
                                                        handleAddIncomeType();
                                                    }
                                                }
                                            }
                                        }}
                                        suffixIcon={
                                            <MdOutlinePayment style={{ color: "#F47939", fontSize: "25px" }} />
                                        }
                                        dropdownRender={(menu) => (
                                            <>
                                                {menu}
                                                {inputValue &&
                                                    !incomeType?.some((opt) =>
                                                        opt.label.toLowerCase().includes(inputValue.toLowerCase())
                                                    ) && (
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                padding: 8,
                                                            }}
                                                        >
                                                            <span>Add "{inputValue}"</span>
                                                            <Button
                                                                type="link"
                                                                onClick={handleAddIncomeType}
                                                                disabled={paymentTypeLoading}
                                                            >
                                                                {paymentTypeLoading ? <Spin size="small" /> : "Add"}
                                                            </Button>
                                                        </div>
                                                    )}
                                            </>
                                        )}
                                    />

                                </Form.Item>
                            </div>

                            <div className="textRow me-2 mt-2">
                                <Form.Item
                                    label="Income Date"
                                    className="firstFormItem"
                                    name="start_date"
                                    rules={[{ required: true, message: "Please select Income date." }]}
                                >
                                    <DatePicker className="formControl select-custom customDatepicker"
                                        prefix={
                                            <SlCalender
                                                style={{ color: "#F47939", fontSize: "25px", height: "20px" }}
                                            />
                                        }
                                        disabledDate={disabledDate}
                                        onChange={(date) =>
                                            handleFieldChange('properties', date, setFormValues)
                                        } />
                                </Form.Item>
                            </div>
                            {SelectedTypeOfIncome?.label === "Recurring" && (
                                <div className="textRow me-2 mt-2">
                                    <Form.Item
                                        label="Frequency"
                                        className="firstFormItem"
                                        name="frequency"
                                        rules={[{ required: true, message: "Please select Frequency." }]}
                                    >
                                        <Select
                                            className="formControl select-custom"
                                            style={{ width: "100%" }}
                                            placeholder="Select property"
                                            labelInValue
                                            options={FrequencyOptions}
                                            showSearch
                                            suffixIcon={
                                                <FaRegCalendarCheck style={{ color: "#F47939", fontSize: "25px" }} />
                                            }
                                            filterOption={(input, option) =>
                                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                            }
                                        />
                                    </Form.Item>
                                </div>
                            )}

                            <div className="textRow me-2 mt-2">
                                <Form.Item
                                    label="Income Name"
                                    className="firstFormItem"
                                    name="notes"
                                    rules={[{ required: true, message: "Please select Income name" }]}
                                >
                                    <Select
                                        loading={loadingIncomeName}
                                        className="formControl select-custom"
                                        style={{ width: "100%" }}
                                        placeholder="Select property"
                                        labelInValue
                                        options={dropdownOptions}
                                        showSearch
                                        open={incomeDropdownOpen}
                                        onDropdownVisibleChange={setIncomeNameDropdown}
                                        onSearch={(value) => setIncomeNameValue(value)}
                                        suffixIcon={
                                            <RiStickyNoteLine
                                                style={{ color: "#F47939", fontSize: "25px", height: "20px" }}
                                            />
                                        }
                                        filterOption={(input, option) =>
                                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                let matchedOption;
                                                if (IncomeNameValue) {
                                                    matchedOption = dropdownOptions?.find(
                                                        (opt) => opt.label.toLowerCase() === IncomeNameValue.toLowerCase()
                                                    );
                                                    if (!matchedOption) {
                                                        addNewOption('notes', IncomeNameValue);
                                                    }
                                                }
                                            }
                                        }}
                                        dropdownRender={(menu) => (
                                            <>
                                                {menu}
                                                {IncomeNameValue &&
                                                    !dropdownOptions.some(
                                                        (opt) => opt.label.toLowerCase() === IncomeNameValue.toLowerCase()
                                                    ) && (
                                                        <div style={{ display: "flex", justifyContent: "space-between", padding: 8 }}>
                                                            <span>Add "{IncomeNameValue}"</span>
                                                            <Button type="link" onClick={() => addNewOption('notes', IncomeNameValue)}>
                                                                Add
                                                            </Button>
                                                        </div>
                                                    )}
                                            </>
                                        )}
                                    />
                                </Form.Item>
                            </div>

                            <div className='submitWrapper'>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" className="authBtn"
                                    >
                                        Save
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </>
                )}
            </div>
        </Modal>
    )
}

export default IncomeModel;